var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ClockRecordFilter"}},[_c('div',{staticClass:"checkInWrap"},[_c('filter-frame',{ref:"filter",attrs:{"filter-form":_vm.depositFilter},on:{"search":_vm.search,"clear":_vm.search}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }